import React from 'react';
import { useCart } from '../../contexts/CartContext';
import type { Product } from '../../types/commerce';
interface AddToCartProps {
  product: Product;
  quantity?: number;
  variant?: 'solid' | 'quiet';
  className?: string;
}
export function AddToCart({
  product,
  quantity = 1,
  variant = 'solid',
  className = ''
}: AddToCartProps) {
  const {
    add
  } = useCart();
  if (!product.availableForSale) {
    return <span className={`inline-flex items-center justify-center rounded-full border border-white/20 px-6 py-3.5 text-base font-medium text-white/40 ${className}`} data-id="element-210" data-mp="3bbrs0301gegf">
        {product.badge ?? 'Sold out'}
      </span>;
  }
  const styles = variant === 'solid' ? 'bg-beat-red text-white hover:bg-white hover:text-beat-black' : 'border border-white/25 text-white hover:border-white hover:bg-white hover:text-beat-black';
  return <button type="button" onClick={() => add(product, quantity)} className={`inline-flex min-h-[52px] items-center justify-center rounded-full px-7 py-3.5 text-base font-medium transition-colors duration-150 ${styles} ${className}`} style={{
    transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)'
  }} data-id="element-211" data-mp="2uev7xk1wrxl">
      Add to cart
    </button>;
}